import { CommApiInstance } from "Utils/CommApiInstance";


const EtcCtxtLstApi = async (
    ctnt_kind_cd:string,
    ctnt_ctgr_cd:string,
    ganeSvcCd:string
) => {
    return await CommApiInstance.post(`comm/${ganeSvcCd}/${ctnt_kind_cd}/${ctnt_ctgr_cd}/ctnt_lst `,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default EtcCtxtLstApi;